export const tokens = {
    track: {
        height: {
            slim: 32,
            thick: 40,
        },
    },
    progress: {
        height: {
            slim: 5,
            thick: 8,
        },
    },
    thumb: {
        size: {
            slim: 14,
            thick: 20,
        },
    },
    handles: {
        gap: {
            slim: 2,
            thick: 2,
        },
        width: {
            slim: 1,
            thick: 2,
        },
        height: {
            slim: 6,
            thick: 8,
        },
    },
};
